import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { useCallback } from 'react';
import { propShape } from '../../../../../helpers/custom-prop-types';
const Select2MultipleInputOnlyRemove = (props) => {
    const { data, innerProps, selectProps } = props;
    const { fields, value } = selectProps;
    const onClick = useCallback((e) => {
        e.stopPropagation();
        const index = value.findIndex((v) => v.label === data.label);
        fields.remove(index);
    }, [data, value, fields]);
    return (_jsx("div", Object.assign({}, innerProps, { onClick: onClick, role: 'presentation' }, { children: _jsx("i", { className: 'css_multiple_icon' }) })));
};
Select2MultipleInputOnlyRemove.propTypes = {
    data: propShape().isRequired,
    innerProps: propShape().isRequired,
    selectProps: propShape().isRequired,
};
export default Select2MultipleInputOnlyRemove;
